import { getCookie, setCookie } from "../utils/cookies";
import { shortGuid } from "../utils/guid";

const ANONYMOUS_UUID_COOKIE = "gl-uuid";
const DEVICE_UUID_KEY = "gl-uuid-device";
const IDENTITY_UUID_COOKIE = "gl-uuid-id";
const GDL_CONTEXT_COOKIE = "gdl-context";

let anonymousUuid, deviceUuid, identityUuid, gdlContext;

export function getAnonymousUuid() {
  anonymousUuid = anonymousUuid || getCookie(ANONYMOUS_UUID_COOKIE);

  return anonymousUuid;
}

function getDeviceUuid() {
  deviceUuid = deviceUuid || getCookie(DEVICE_UUID_KEY);

  return deviceUuid;
}

export function getIdentityUuid() {
  identityUuid = identityUuid || getCookie(IDENTITY_UUID_COOKIE);

  return identityUuid;
}

export function getGdlContext() {
  gdlContext = gdlContext || getCookie(GDL_CONTEXT_COOKIE);

  return gdlContext;
}

export function ensureAnonymousUuid() {
  const value = getAnonymousUuid() || `gdl-ca-${shortGuid()}`;

  setCookie(ANONYMOUS_UUID_COOKIE, value, { expires: 10 * 365 });
}

export function ensureDeviceUuid() {
  const value = getDeviceUuid() || `gdl-device-${shortGuid()}`;

  setCookie(DEVICE_UUID_KEY, value, { expires: 10 * 365 });
}
